import type { Ref } from 'vue';
import { ref } from 'vue';

export const useEntities = <T>() => ({
  entities: ref<Array<T>>([]) as Ref<Array<T>>,
});
